<template><span></span></template>
<script>export default {
    mounted() {
    	let hubScript = document.createElement('script');
        hubScript.setAttribute('id', 'hs-script-loader');
        hubScript.setAttribute('async', 'async');
        hubScript.setAttribute('defer', 'defer');
        hubScript.setAttribute('src', '//js-eu1.hs-scripts.com/139932032.js');
        document.head.appendChild(hubScript);
    }
}</script>